import { Link } from "react-router-dom";
import { ArrowUpRight, Instagram, Music2 } from "lucide-react";
import { INSTAGRAM_URL, TIKTOK_URL } from "@/constants/social";

export const Footer = () => (
  <footer className="border-t border-white/10 px-5 py-10 sm:px-8">
    <div className="mx-auto flex max-w-7xl flex-col justify-between gap-6 text-sm text-zinc-500 lg:flex-row lg:items-center">
      <p>© 2026 Vyora Event Pilot Series • 03.10.2026 • Welcome to the pilot.</p>
      <div className="flex flex-wrap items-center gap-4">
        <a data-testid="footer-instagram-link" href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-zinc-400 transition-colors duration-200 hover:text-[#E5C378]">
          <Instagram className="h-4 w-4" /> Instagram
        </a>
        <a data-testid="footer-tiktok-link" href={TIKTOK_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-zinc-400 transition-colors duration-200 hover:text-[#E5C378]">
          <Music2 className="h-4 w-4" /> TikTok
        </a>
        <Link data-testid="footer-organizer-link" to="/admin" className="inline-flex items-center gap-2 text-zinc-400 transition-colors duration-200 hover:text-[#E5C378]">
          Veranstalterbereich <ArrowUpRight className="h-4 w-4" />
        </Link>
      </div>
    </div>
  </footer>
);
